import { render, staticRenderFns } from "./VentasTrimestral.vue?vue&type=template&id=5e649158&"
import script from "./VentasTrimestral.vue?vue&type=script&lang=js&"
export * from "./VentasTrimestral.vue?vue&type=script&lang=js&"
import style0 from "./VentasTrimestral.vue?vue&type=style&index=0&id=5e649158&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports